export { HomeTrustSeals } from './HomeTrustSeals';
export type { HomeTrustSealsProps } from './HomeTrustSeals';
